import { render, staticRenderFns } from "./CognitoAuth.vue?vue&type=template&id=63a73940&"
import script from "./CognitoAuth.vue?vue&type=script&lang=js&"
export * from "./CognitoAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports